import { PropsWithChildren } from "react";
import { styled } from "styled-components";

import WebCardPreviews from "./WebCardPreviews";
import WebButtonPreviews from "./WebButtonPreviews";
import WebTagPreviews from "./WebTagPreviews";
import { Col, Row } from "reactstrap";
import WebBarPreviews from "./WebBarPreviews";
import WebComponentPreview from "./WebComponentPreview";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;
  background: var(--colors-surfaces-body);
  padding: 20px;
  flex-wrap: nowrap;
  height: calc(100vh - 101px);
  width: 100%;
`;

const PreviewContainer = styled.div`
  flex-direction: row;
  align-items: flex-start;
`;

type WebPreviewsProps = {
  className?: string;
};

type PreviewWrapperProps = PropsWithChildren<{
  title: string;
  className?: string;
}>;

function PreviewWrapper({ children, title }: PreviewWrapperProps) {
  return (
    <PreviewContainer>
      <h2>{title}</h2>
      {children}
    </PreviewContainer>
  );
}

export default function WebPreviews({ className }: WebPreviewsProps) {
  return (
    <Container>
      <Row>
        <Col>
          <PreviewWrapper title="Navigation Bar">
            <WebBarPreviews className={className} />
          </PreviewWrapper>
        </Col>
      </Row>
      <Row>
        <Col md={4} lg={4} xl={3}>
          <PreviewWrapper title="Cards">
            <WebCardPreviews className={className} />
          </PreviewWrapper>
        </Col>
        <Col md={4} lg={4} xl={3}>
          <PreviewWrapper title="Components">
            <WebComponentPreview className={className} />
          </PreviewWrapper>
        </Col>
        <Col md={4} lg={4} xl={3}>
          <PreviewWrapper title="Buttons">
            <WebButtonPreviews className={className} />
          </PreviewWrapper>
        </Col>
        <Col md={4} lg={4} xl={3}>
          <PreviewWrapper title="Toasts/Tags">
            <WebTagPreviews className={className} />
          </PreviewWrapper>
        </Col>
      </Row>
    </Container>
  );
}
